// src/features/live/LiveDetailPage.tsx — live channel detail/watch route at
// /live/:id. Same placeholder treatment as LivePage's Featured Live block
// (player + chat panel) — see slice-4-xl §2. Mirrors VideoDetailPage's shape.
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '@/theme/media';
import { useLiveChannel, useLive } from '@/hooks';
import { FeaturedLive } from './FeaturedLive';
import { LiveChatPanel } from './LiveChatPanel';
import { PreviewNotice } from '@/components/PreviewNotice';
import { PREVIEW_NOTICE } from './meta';

const Wrap = styled.section`
  max-width: 1040px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 16px;
  ${media.tabletDown`grid-template-columns: 1fr;`}
`;

const NotFoundWrap = styled.div`
  padding: 40px 16px;
  text-align: center;
  font-family: ${({ theme }) => theme.font.body};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function LiveDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { channel, loaded } = useLiveChannel(id);
  const { creators } = useLive();
  const creator = creators.find((c) => c.id === channel?.authorId);

  if (loaded && !channel) {
    return (
      <NotFoundWrap>
        <p>This live channel couldn&apos;t be found.</p>
        <Link to="/live">Back to Live</Link>
      </NotFoundWrap>
    );
  }

  if (!channel) return null;

  return (
    <Wrap>
      <PreviewNotice text={PREVIEW_NOTICE} />
      <Grid>
        {/* h1 — this is the page's title (unlike LivePage, which already has
            its own <h1>Live</h1> and needs FeaturedLive's default h2). */}
        <FeaturedLive channel={channel} creator={creator} headingLevel="h1" />
        <LiveChatPanel messages={channel.chat} />
      </Grid>
    </Wrap>
  );
}
